var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 
 * @file Skills sidebar component
 * @author Box
 */

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import noop from 'lodash/noop';
import LoadingIndicator from 'box-react-ui/lib/components/loading-indicator/LoadingIndicator';
import { SKILLS_TRANSCRIPT } from '../../constants';
import messages from '../messages';
import SidebarContent from './SidebarContent';
import APIContext from '../APIContext';
import SidebarSkills from './Skills/SidebarSkills';
import API from '../../api';

var SkillsSidebar = function (_React$PureComponent) {
    _inherits(SkillsSidebar, _React$PureComponent);

    function SkillsSidebar() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SkillsSidebar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SkillsSidebar.__proto__ || Object.getPrototypeOf(SkillsSidebar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            errors: {}
        }, _this.updatePreviewTranscript = function (cards) {
            var _this$props = _this.props,
                getPreview = _this$props.getPreview,
                getViewer = _this$props.getViewer;

            var preview = getPreview ? getPreview() : null;
            var viewer = getViewer ? getViewer() : null;
            var transcriptCard = cards.find(function (card) {
                return card.skill_card_type === SKILLS_TRANSCRIPT;
            });
            if (!transcriptCard || !preview) {
                return;
            }

            if (!viewer) {
                preview.addListener('load', function (_ref2) {
                    var loadedViewer = _ref2.viewer;

                    if (typeof loadedViewer.loadAutoGeneratedCaptions === 'function') {
                        loadedViewer.loadAutoGeneratedCaptions(transcriptCard);
                    }
                });
            } else if (typeof viewer.loadAutoGeneratedCaptions === 'function') {
                viewer.loadAutoGeneratedCaptions(transcriptCard);
            }
        }, _this.onSave = function (index) {
            var removes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var adds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var replaces = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
            var _this$props2 = _this.props,
                api = _this$props2.api,
                file = _this$props2.file;
            var _this$state = _this.state,
                _this$state$cards = _this$state.cards,
                cards = _this$state$cards === undefined ? [] : _this$state$cards,
                errors = _this$state.errors;
            var _file$permissions = file.permissions,
                permissions = _file$permissions === undefined ? {} : _file$permissions;

            var card = cards[index];
            var path = '/cards/' + index;
            var ops = [];

            if (!permissions.can_upload || !card) {
                return;
            }

            if (Array.isArray(replaces)) {
                replaces.forEach(function (_ref3) {
                    var replaced = _ref3.replaced,
                        replacement = _ref3.replacement;

                    var idx = card.entries.findIndex(function (entry) {
                        return entry === replaced;
                    });
                    if (idx > -1) {
                        ops.push({
                            op: 'replace',
                            path: path + '/entries/' + idx,
                            value: replacement
                        });
                    }
                });
            }

            if (Array.isArray(removes)) {
                var deletes = [];
                removes.forEach(function (removed) {
                    var idx = card.entries.findIndex(function (entry) {
                        return entry === removed;
                    });
                    if (idx > -1) {
                        deletes.push(idx);
                    }
                });
                deletes.sort().reverse().forEach(function (idx) {
                    ops.push({
                        op: 'remove',
                        path: path + '/entries/' + idx
                    });
                });
            }

            if (Array.isArray(adds)) {
                adds.forEach(function (added) {
                    ops.push({
                        op: 'add',
                        path: path + '/entries/-',
                        value: added
                    });
                });
            }

            // If no ops, don't proceed
            if (ops.length === 0) {
                return;
            }

            // Add test ops before any other ops
            ops.splice(0, 0, {
                op: 'test',
                path: path,
                value: card
            });

            api.getMetadataAPI(false).updateSkills(file, ops, function (updatedCards) {
                var clone = _extends({}, errors);
                delete clone[index];
                _this.updatePreviewTranscript(updatedCards);
                _this.setState({ cards: updatedCards, errors: clone });
            }, function () {
                var clone = _extends({}, errors);
                clone[index] = true;
                _this.setState({ errors: clone });
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SkillsSidebar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props = this.props,
                api = _props.api,
                file = _props.file;

            api.getMetadataAPI(false).getSkills(file, function (cards) {
                _this2.updatePreviewTranscript(cards);
                _this2.setState({ cards: cards });
            }, noop);
        }

        /**
         * Updates Preview with transcript data
         *
         * @private
         * @param {Array<SkillCard>} cards - Skills cards
         * @return {void}
         */


        /**
         * Updates skill metadata
         *
         * @private
         * @param {string} id - File id
         * @return {void}
         */

    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                file = _props2.file,
                getViewer = _props2.getViewer;
            var _state = this.state,
                cards = _state.cards,
                errors = _state.errors;


            return React.createElement(
                SidebarContent,
                {
                    title: React.createElement(FormattedMessage, messages.sidebarSkillsTitle)
                },
                cards ? React.createElement(SidebarSkills, {
                    file: file,
                    cards: cards,
                    errors: errors,
                    getViewer: getViewer,
                    onSkillChange: this.onSave
                }) : React.createElement(LoadingIndicator, null)
            );
        }
    }]);

    return SkillsSidebar;
}(React.PureComponent);

export { SkillsSidebar as SkillsSidebarComponent };
export default (function (props) {
    return React.createElement(
        APIContext.Consumer,
        null,
        function (api) {
            return React.createElement(SkillsSidebar, _extends({}, props, { api: api }));
        }
    );
});